<template>
  <div class="spl-daily-cargo-edit-action-bar">
    <form-button
      style="grid-column: 1"
      @onClick="handleCancel">
      Cancel
    </form-button>
    <div style="grid-column: 2" />
    <form-button
      style="grid-column: 3"
      data-cy="daily-cargo-edit-next"
      :disabled="invalid"
      @onClick="handleSave">
      Save
    </form-button>
  </div>
</template>

<script>

export default {
  name: 'DailyCargoActionBar',
  props: {
    invalid: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
  },
  methods: {
    handleCancel () {
      this.$emit('onCancel')
    },
    handleSave () {
      this.$emit('onSave')
    }
  }
}
</script>

<style lang="scss">
    @import '../../../variables.scss';

    .spl-daily-cargo-edit-action-bar {
        background-color: $yellowButtonLabelHover;
        bottom: 0;
        height: 70px;
        padding: 15px $mainPadding;
        position: fixed;
        display: grid;
        grid-template-columns: 150px auto 150px;
        width: 100%;

        .spl-label {
            color: $darkerYellow;
        }
        .spl-input {
            width: 450px;
        }
        .col3 {
            .spl-button {
                background-color: $footerButtonYellow;
                color: $yellowButtonLabel;
                margin: 0 2px 0 0;
                padding: 0 10px;
            }
        }
        .col2 {
            .spl-button {
                background-color: $mainInputColor;
                color: $footerButtonDarkGreyText;
                float: right;
            }
        }
    }
</style>
